// Fade-In-Right animation
document.addEventListener("DOMContentLoaded", function () {
    const fadeInRightElements = document.querySelectorAll(".has-fade-in-right");
    if (fadeInRightElements.length > 0) {
        fadeInRightElements.forEach(function (element) {
            gsap.from(element, {
                scrollTrigger: {
                    trigger: element,
                    start: "top 85%",
                    toggleActions: "play none none none"
                },
                opacity: 0,
                x: 50, // Start 50px from the right
                duration: 1.5,
                ease: "power2.out",
            });
        });
    }
});